import { RootState } from '~/redux/store';

export const selectSelectedTearOuts = ({ tearOut }: RootState) =>
  tearOut.selectedTearOuts;
